"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSnapshotSerde = void 0;
/**
 * Serializer/deserializer interface for static document snapshots. Must carry a current version for the serialization
 * direction, and be able to deserialize static document snapshot data that carries any schema tag.
 */
class DocumentSnapshotSerde {
}
exports.DocumentSnapshotSerde = DocumentSnapshotSerde;
//# sourceMappingURL=snapshot.js.map